import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  CircularProgress,
  Divider,
  Tooltip,
  Typography,
} from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import ProductDetailsForm from "./product-details-form";
import {
  ComponentDetails,
  FacilityProductDetailsForm,
  ProductDetails,
  RawMaterialDetails,
} from "../../../sc-models/facility-product-details-dto";
import ComponentDetailsForm from "./component-details-form";
import RawMaterialDetailsForm from "./raw-material-details-form";
import CompoenentRawMaterialDetailsForm from "./component-raw-material";
// import { SCAppConfig } from '../../../../../shared/app-configs/sc-app-config';
import { useApi } from "../../../../../shared/hooks/useApi";
import useNotification from "../../../../../shared/hooks/useNotification";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { API_ROUTES } from "../../../../../shared/app-configs/sc-app-config";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { isAdmin } from "../../../../../shared/utils/admin-utils";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import { Utills } from "../../../../../shared/app-configs/utilit";
import { downloadPDF } from "../../../../../shared/hooks/file-downloader";
import PdfViewer from "../../../../../shared/components/preview/pdf-viewer";
import ViewerModalPopup from "../../../../../shared/components/modals/viewerModal";
import {
  downloadDocx,
  DownloadDocxOptions,
} from "../../../../../shared/components/document/docx-downloader";
import RenderDetailPanel from "./render-detail-panel";
import {
  mapFacilityProductPayload,
  mapProductData,
  fetchProductDetails,
} from "./facility-product-dtails-apis";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";

const initProductDetails: ProductDetails = {
  productNo: "",
  associatedFacilityNo: [],
  standardLabelGrade: [],
  productCategory: "",
  productCategoryUserSpecificTerm: "",
  productDetail: "",
  productDetailUserSpecificTerm: "",
};

const initComponentDetails: ComponentDetails = {
  productComponentNo: "",
  componentDetail: "",
  componentStandardLabelGrade: [],
};

const initProductState: FacilityProductDetailsForm = {
  productDetails: initProductDetails,
  componentDetails: [], //initComponentDetails,
  rawMaterialDetails: [], // Array of RawMaterialDetails
  componentRawMaterialDetails: [], // Array of ComponentRawMaterialDetails
};
const mapToInitFacilityState = (
  apiResponse: any
): FacilityProductDetailsForm[] => {
  Utills.cl(apiResponse);

  return apiResponse.facilityProductDetails.map((product: any) => ({
    productDetails: {
      productNo: product.scProductNo,
      associatedFacilityNo: product.associatedFacilityNo || [],
      standardLabelGrade: product.scProductStandardLabelGrade || [],
      productCategory: product.scProductCategoryCode,
      productCategoryUserSpecificTerm:
        product.scProductCategoryUserSpecificTerm,
      productDetail: product.scProductDetailCode,
      productDetailUserSpecificTerm: product.scProductDetailUserSpecificTerm,
    },
    componentDetails: product.scProductComponentDetails
      ? product.scProductComponentDetails.map((pdctComp: any) => {
          return {
            productComponentNo: pdctComp.scProductComponentNo,
            componentDetail: pdctComp.scComponentDetail,
            componentStandardLabelGrade:
              pdctComp.scComponentStandardLabelGrade || [],
          };
        })
      : [initComponentDetails],
    componentRawMaterialDetails:
      product.scProductComponentDetails?.flatMap((comp:any)=>
        comp?.scProductComponentRawMaterialDetails.map(
        (rawMaterial: {
          scComponentRawMaterialCode: string;
          scComponentRawMaterialPercentage: string;
        }) => ({
          productComponentNo:comp?.scProductComponentNo,
          componentRawMaterialCode: rawMaterial.scComponentRawMaterialCode,
          componentRawMaterialPercentage: String(
            rawMaterial.scComponentRawMaterialPercentage
          ),
        })
      ) || []),
    rawMaterialDetails: product.facilityProductRawMaterialDetails.map(
      (rawMaterial: {
        scProductRawMaterialCode: string;
        scProductRawMaterialPercentage: string;
      }) => ({
        rawMaterialCode: rawMaterial.scProductRawMaterialCode,
        rawMaterialPercentage: String(
          rawMaterial.scProductRawMaterialPercentage
        ),
      })
    ),
  }));
};

export interface FacilityProductRawMaterialDetail {
  scProductRawMaterialPercentage: string;
  scProductRawMaterialCode: string;
}

export interface ProductComponentRawMaterialDetail {
  scComponentRawMaterialCode: string;
  scComponentRawMaterialPercentage: string;
}

export interface ProductComponentDetail {
  scProductComponentNo: string;
  scComponentDetail: string;
  scComponentStandardLabelGrade: string[];
  scProductComponentRawMaterialDetails: ProductComponentRawMaterialDetail[];
}

export interface FacilityProductDetail {
  scProductNo: string;
  associatedFacilityNo: string[];
  scProductStandardLabelGrade: string[];
  scProductCategoryCode: string;
  scProductCategoryUserSpecificTerm: string;
  scProductDetailCode: string;
  scProductDetailUserSpecificTerm: string;
  scProductComponentDetails: ProductComponentDetail[];
  facilityProductRawMaterialDetails: FacilityProductRawMaterialDetail[];
}

export interface FacilityProductDetailsRequest {
  scId: string;
  isPostCreation: string;
  facilityProductDetails: FacilityProductDetail[];
}

const mapToFacilityDetailsReq = (
  data: any,
  SC_ID: string,
  isPostCreation: string
): FacilityProductDetailsRequest => {
  return {
    scId: SC_ID,
    isPostCreation: isPostCreation,
    facilityProductDetails: data.map((item: any) => ({
      scProductNo: item.productDetails.productNo,
      scProductStandardLabelGrade: item.productDetails.standardLabelGrade,
      scProductStandardLabelGradeDescription:
        useTransactionCertificateStore
          .getState()
          .getFPDStdLblGrd.filter((option: any) =>
            item.productDetails.standardLabelGrade.includes(option.value)
          )
          .map((option: any) => option.label) || [],
      scProductCategoryCode: item.productDetails.productCategory,
      scProductCategoryCodeDescription:
        useTransactionCertificateStore
          .getState()
          .getFPDPrdtCat.find(
            (option: any) =>
              option.value === (item.productDetails.productCategory ?? "")
          )?.label ?? "",
      scProductCategoryUserSpecificTerm:
        item.productDetails.productCategoryUserSpecificTerm,
      scProductDetailCode: item.productDetails.productDetail,
      scProductDetailCodeDescription:
        useTransactionCertificateStore
          .getState()
          .getFPDPrdtDtl.find(
            (option: any) =>
              option.value === (item.productDetails.productDetail ?? "")
          )?.label ?? "",
      scProductDetailUserSpecificTerm:
        item.productDetails.productDetailUserSpecificTerm,
      associatedFacilityNo: item.productDetails.associatedFacilityNo || [],
      scProductComponentDetails: [
        {
          scProductComponentNo: item.componentDetails.productComponentNo,
          scComponentDetail: item.componentDetails.componentDetail,
          scComponentStandardLabelGrade:
            item.componentDetails.componentStandardLabelGrade,
          scComponentStandardLabelGradeDescription:
            useTransactionCertificateStore
              .getState()
              .getFPDStdLblGrd.filter((option: any) =>
                item.componentDetails.componentStandardLabelGrade.includes(
                  option.value
                )
              )
              .map((option: any) => option.label) || [],
          scProductComponentRawMaterialDetails:
            item.componentRawMaterialDetails.map((rm: any) => ({
              scComponentRawMaterialCode: rm.componentRawMaterialCode,
              scComponentRawMaterialCodeDescription:
                useTransactionCertificateStore
                  .getState()
                  .getFPDPrdtRawMtrlCodes.find(
                    (option: any) =>
                      option.value === (rm.componentRawMaterialCode ?? "")
                  )?.label ?? "",
              scComponentRawMaterialPercentage:
                rm.componentRawMaterialPercentage
                  ? rm.componentRawMaterialPercentage.toString()
                  : "",
            })),
        },
      ],
      isPostCreation: "yes",
      facilityProductRawMaterialDetails: item.rawMaterialDetails.map(
        (rm: any) => ({
          scProductRawMaterialCode: rm.rawMaterialCode,
          scProductRawMaterialCodeDescription:
            useTransactionCertificateStore
              .getState()
              .getFPDPrdtRawMtrlCodes.find(
                (option: any) => option.value === (rm.rawMaterialCode ?? "")
              )?.label ?? "",
          scProductRawMaterialPercentage: rm.rawMaterialPercentage.toString(),
        })
      ),
    })),
  };
};

interface ProductManagementComponentProps {
  completionMap: any;
  onNextTab: () => Promise<void>;
}

const ProductManagementComponent: React.FC<ProductManagementComponentProps> = ({
  completionMap,
  onNextTab,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [data, setData] = useState<FacilityProductDetailsForm[]>([]);  
  const [rowCount, setRowCount] = useState<number>(0);
  const [tableData, setTableData] = useState<any[]>([]);
  const [apiData, setAPIData] = useState<FacilityProductDetailsForm[]>([]);
  const [productData, setProductData] =
    useState<FacilityProductDetailsForm>(initProductState);
  const {
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  const executeNewGet = useApi().executeGet;
  const { formtype, SC_ID } = useParams();
  const hasCreateSC = formtype === "create-sc";
  const hasSubmitSC: boolean = formtype === "submited-sc";
  const [showJson, setShowJson] = useState(true);
  const [isPostCreation, setIsPostCreation] = useState("yes");
  const [showSCSubmit, setShowSCSubmit] = useState(true);
  const { notify } = useNotification();
  const { isRestrictPopUpSave, setRestrictPopUpSave, cbLicensingCode } =
    useTransactionCertificateStore();
  const isViewMode = isAdmin();
  const [isProductNoRequired, setIsProductNoRequired] = useState(true);
  const [hasChanges, setHasChanges] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(true);
  const [previewOpen, setpreviewOpen] = useState<boolean>(false);
  const [responseData, setResponseData] = useState([]);
  const [productId, setProductId] = useState<string | null>(null);
  const [facilityId, setFacilityId] = useState<string | null>(null);
  const [productNo, setProductNo] = useState<string | null>(null);
  const [pendingSave, setPendingSave] = useState<any>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [scDetails, setScDetails] = useState<any>(null);
  const [pagination, setPagination] = useState<Pagination>({
      pageIndex: 0,
      pageSize: 10,
    });
  // Toggle modal open/close state
  const togglepreviewDrawer = () => setpreviewOpen((prev) => !prev);
  const navigate = useNavigate();
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    replaceTableDatas,
    updateField,
    setDeleteSave,
    setEditSave,
    resetFormValueByPage,
    getDeleteSave,
  } = useFormActions("sc-facilityproductdetails");
  const loadFacilityData = async () => {
    try {
      const response: any = await executeGet(API_ROUTES.GET_FACILITY_DETAILS, {
        scId: SC_ID,
      });

      console.log("Facility Details:", response.data.response);

      // Defensive check
      if (!Array.isArray(response.data.response)) {
        throw new Error("Invalid response: Expected facility details array");
      }

      // Set full facility details for later usage
      setResponseData(response.data.response);
    } catch (error: any) {
      console.error("Failed to load facility details:", error.message || error);
      notify(error.message || "Failed to load facility details", "error");
    }
  };

  const loadScDetails = async () => {
    try {
      const response: any = await executeGet(API_ROUTES.GET_SC_DETAILS, {
        scId: SC_ID,
      });
      if (response?.data) {
        setScDetails(response.data);
      }
    } catch (error: any) {
      console.error("Failed to load SC details:", error.message || error);
    }
  };

  const loadFormData = async () => {
    try {
      const response: any = await executeGet(
        API_ROUTES.GET_PRODUCT_FACILITY_DETAILS,
        { scId: SC_ID ,
          limit:pagination?.pageSize,
          offset:pagination?.pageIndex*pagination?.pageSize
        }
      );

      const result = mapProductData(response.data);
      setRowCount(response?.data?.no_of_records);
      setTableData(result);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  useEffect(() => {
    // Check if data is different from apiData
    const isDataChanged = JSON.stringify(data) !== JSON.stringify(apiData);
    setHasChanges(isDataChanged);
  }, [data, apiData]);

  useEffect(() => {
    if (SC_ID || !hasCreateSC) {
      loadFormData();
      loadScDetails();
    }
    loadFacilityData();
    setRestrictPopUpSave(false);
  }, [SC_ID,pagination?.pageIndex]);

  const handleSCSave = async () => {
    try {
      const params = {
        scId: SC_ID,
        scCblicensingCode: cbLicensingCode,
      };
      const result: any = await executePost(API_ROUTES.SAVE_SC, params);
      if (result.status === 200) {
        await setTimeout(() => {
          setLoadingState(false);
          setShowJson(false);
        }, 5000);
        notify("Saved Successfully", "success");
        setIsSubmitted(false);
        // navigate('/sc-dashboard');
      } else {
        setShowJson(true);
        notify("Unable to Save", "error");
      }
    } catch (error) {
      console.error("Error saving Facility Details:", error);
      // notify("Error saving Facility Details", "error");
    }
  };

  const handleSCSubmit = async () => {
    try {
      const params = {
        scId: SC_ID,
      };
      const result: any = await executePost(API_ROUTES.SUBMIT_SC, params);
      if (result.status === 200) {
        await setTimeout(() => {
          setLoadingState(false);
          setShowJson(false);
        }, 5000);
        notify("Submitted Successfully", "success");
        setIsSubmitted(false);
        // navigate('/sc-dashboard');
      } else {
        setShowJson(true);
        notify("Unable to Submit", "error");
      }
    } catch (error) {
      console.error("Error saving Facility Details:", error);
      // notify("Error saving Facility Details", "error");
    }
  };

  useEffect(() => {
    if (hasChanges) {
      setIsSaved(false);
    }
  }, [hasChanges]);

  //  const getFacilityIdByFacilityNo = (facilityNo: string[], productData: any[]): string => {
  //     const matchedFacility = productData.find((facility) => facility.facilityNo === facilityNo);
  //     return matchedFacility ? matchedFacility.facilityId : '';
  //   };

  const getFacilityIdByFacilityNo = (
    facilityNos: string[],
    productData: any[]
  ): string[] => {
    if (!Array.isArray(facilityNos)) {
      return [];
    }

    return facilityNos
      .map((facilityNo) => {
        const matchedFacility = productData.find(
          (facility) => facility.facilityNo === facilityNo
        );
        return matchedFacility ? matchedFacility.facilityId : "";
      })
      .filter((id) => id !== ""); // Filter out empty IDs
  };

  const handleSave = async (payload: any) => {
    try {
      if (!SC_ID) {
        return;
      }
      const associatedFacilityNo =
        payload.facilityProductDetails[0].associatedFacilityNo;
      const facilityIds = getFacilityIdByFacilityNo(
        associatedFacilityNo,
        responseData
      );
      const arrayParam = JSON.stringify(facilityIds);
      const oldFacilityIdArray = facilityId ? [facilityId] : facilityIds;
      const oldFacilityIdParam = JSON.stringify(oldFacilityIdArray);

      const url = `${
        API_ROUTES.POST_FACILITY_PRODUCT_DETAILS
      }?scId=${SC_ID}&facilityId=${arrayParam}${`&oldFacilityId=${oldFacilityIdParam}`}`;

      // const queryString = queryParams.toString();
      // const finalUrl = `${API_ROUTES.POST_FACILITY_PRODUCT_DETAILS}?${queryString}`;

      const result: any = await executePost(url, payload);
      if (result.status == 200) {
        notify("Data Saved Successfully", "success");
        await onNextTab();
        setProductData(initProductState);
        setProductId(null);
        setFacilityId(null);
        setProductNo(null);
        setActiveStep(0);
        toggleDrawer();
        loadFormData();
      }
    } catch (error) {
      console.error("Error saving Facility Details:", error);
      notify("Error saving Facility Details", "error");
    }
  };

  const productDetailsRef = useRef<any>(null);
  const componentDetailsRef = useRef<any>(null);

  const toggleDrawer = () => {
    if (drawerOpen) {
      setActiveStep(0);
      setRestrictPopUpSave(false);
      setProductData(initProductState);
      setProductId(null);
      setFacilityId(null);
      setProductNo(null);
    }
    setDrawerOpen((prev) => !prev);
  };

  const handleDataUpdate = (
    stepKey: keyof FacilityProductDetailsForm,
    updatedData: any
  ) => {
    setProductData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  const formRefs = [productDetailsRef, null, componentDetailsRef, null];
  const handleNext = async () => {
    if (isViewMode) {
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      return;
    }
    const currentRef = formRefs[activeStep];
    Utills.cl(currentRef);
    if (currentRef?.current) {
      const errors = await currentRef.current.validateForm();
      Object.keys(errors).forEach((fieldName) => {
        currentRef.current.setFieldTouched(fieldName, true, false);
      });
      if (Object.keys(errors).length === 0) {
        currentRef.current.submitForm();
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      } else {
        notify("Enter the mandatory fields", "error");
      }
    } else if (
      productData.rawMaterialDetails.length > 0 ||
      !isProductNoRequired
    ) {
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    } else {
      notify("Enter the mandatory fields", "error");
      return;
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };

  const handleFinish = async () => {
    if (SC_ID) {
      const payload = mapFacilityProductPayload(
        productData,
        SC_ID,
        productId || undefined
      );

      // Check if productNo exists and has changed
      // if (productId && payload.facilityProductDetails[0].scProductNo) {
      //   // Find the existing record in tableData that matches the productId
      //   const existingRecord = tableData.find(
      //     (item) => item.productId === productId
      //   );

      // If record exists and productNo has changed, handle deletion
      // if (existingRecord && existingRecord.productDetails.productNo !== payload.facilityProductDetails[0].scProductNo) {
      //   const row = {
      //     original: {
      //       productNo: payload.facilityProductDetails[0].scProductNo,
      //       productId: productId,
      //       facilityId: facilityId
      //     },
      //   };

      //   onEditDelete(row);
      //   // The actual save will happen in handleConfirmSave after deletion
      //   setPendingSave(payload);
      //   setIsSubmitted(false)
      //   return;
      // }
      // }
      // If no changes to product number or new product, save directly
      handleSave(payload);
    }
  };

  const handleConfirmSave = async () => {
    try {
      // Delete the existing record first

      // If we have a pending save payload, save it now
      // if (pendingSave) {
      //   await handleSave(pendingSave);
      //   setPendingSave(null);
      // }
      await executeDelete(`${API_ROUTES.DELETE_API}`, {
        scId: SC_ID,
        productId: productId,
        facilityId: facilityId,
        productNo: productNo,
      });

      await loadFormData();
      setDialogOpen(false);
      setProductId(null);
      setFacilityId(null);
      setProductNo(null);
      notify("Successfully deleted", "success");
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  // const onEdit = (row: any) => {
  //   console.log("I am in edit see here")
  //   const rowData = row.original;
  //   console.log("rowData------------>",JSON.stringify(rowData))
  //   setProductData(rowData);
  //   setEditingIndex(row.index);
  //   toggleDrawer();
  // };

  const onEdit = (row: any) => {
    const value = row?.original;
    setProductId(value.productId);
    setFacilityId(value.facilityId);
    setProductNo(value.productNo);
    if (SC_ID && value.facilityId && value.productId) {
      fetchProductDetails(
        executeNewGet,
        SC_ID,
        value.facilityId,
        value.productId
      )
        .then((data) => {
          console.log("data------------>", data.data);
          const mappedData = mapToInitFacilityState(data.data)[0];
          console.log("mappedData------------>", mappedData);
          setProductData(mappedData);
          setEditingIndex(row.index);
          toggleDrawer();
        })
        .catch((err) => {
          notify(err.message, "error");
          console.error("Error fetching product details:", err);
        });
    } else {
      notify("Missing required IDs for editing", "error");
    }
  };

  const onDelete = (row: any) => {
    setProductId(row?.original?.productId);
    setFacilityId(row?.original?.facilityId);
    setProductNo(row?.original?.productDetails?.productNo);
    setDialogOpen(true);
    setPopUpBtnName("Yes");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(`Are you sure want to delete it`);
  };

  // const onEditDelete = (row: any) => {
  //   setProductId(row?.original?.productId);
  //   setFacilityId(row?.original?.facilityId);
  //   setDialogOpen(true);
  //   setPopUpBtnName("Save");
  //   setPopUpTitle("Confirm Edit ?");
  //   setPopUpMessage(`Editing a Product will remove all the Associated Records, are you sure want to edit it`);
  // };

  const handleCancelSave = () => {
    setDialogOpen(false);
    // setData(apiData);
    // setProductId(null);
    // setFacilityId(null);
  };

  const steps = [
    {
      label: "Product Details",
      content: (
        <ProductDetailsForm
          formRef={productDetailsRef}
          productData={productData.productDetails}
          setProductData={(data) => handleDataUpdate("productDetails", data)}
          isProductNoRequired={isProductNoRequired}
          setIsProductNoRequired={setIsProductNoRequired}
        />
      ),
    },
    {
      label: "Facility Product Raw Material Details",
      content: (
        <RawMaterialDetailsForm
          // formRef={rawMaterialRef}
          productData={productData.productDetails}
          isProductNoRequired={isProductNoRequired}
          rawMaterialInfoData={productData.rawMaterialDetails}
          setRawMaterialInfoData={(data) =>
            handleDataUpdate("rawMaterialDetails", data)
          }
        />
      ),
    },
    {
      label: "Product Component Details",
      content: (
        <ComponentDetailsForm
          formRef={componentDetailsRef}
          componentData={productData.componentDetails}
          setComponentData={(data) =>
            handleDataUpdate("componentDetails", data)
          }
        />
      ),
    },
    {
      label: "Product Component Raw Material",
      content: (
        <CompoenentRawMaterialDetailsForm
          rawMaterialInfoData={productData?.componentRawMaterialDetails}
          componentData = {productData?.componentDetails}
          setRawMaterialInfoData={(data) =>
            handleDataUpdate("componentRawMaterialDetails", data)
          }
        />
      ),
    },
  ];

  const actions: any[] = [
    ...(activeStep !== 0
      ? [
          {
            label: "Back",
            onClick: handleBack,
            variant: "contained",
            color: "default",
          },
        ]
      : []),
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained",
      color: "primary",
      disabled:
        activeStep === 1 || activeStep === 2 ||  activeStep === 3 ? isRestrictPopUpSave : false,
    },
  ];

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "productDetails.productNo",
      header: "Product No.",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productDetails.standardLabelGrade",
      header: "Standard Label Grade",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productDetails.productCategory",
      header: "Product Category",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productDetails.productCategoryUserSpecificTerm",
      header: "Product Category User Specific Term",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productDetails.productDetail",
      header: "Product Detail",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "productDetails.productDetailUserSpecificTerm",
      header: "Product Detail User Specific Term",
      minSize: 60,
      maxSize: 150,
    },
  ];

  const handleDownload = async () => {
    // Define the download options based on your API requirements
    setIsDownloading(true);
    
    let filename = 'sc_download.docx';
    if (scDetails) {
      const cbCode = cbLicensingCode || 'CB';
      const scNumber = (scDetails.scNo || 'SC').replace(/\s+/g, '_');
      const lastUpdated = scDetails.scLastUpdated || '';
      const dateStr = lastUpdated.replace(/-/g, ''); 
      filename = `sc_${cbCode}_${scNumber}_${dateStr}.docx`;
    }
    
    const options: DownloadDocxOptions = {
      apiUrl: API_ROUTES.GET_WORD_DOC,
      params: {
        scId: SC_ID ?? "", // If SC_ID is undefined, default to an empty string
        cbCode: cbLicensingCode,
      },
      headers: {
        // Optional headers if needed
      },
      filename: filename,
    };

    try {
      notify("Starting Download", "info");
      await downloadDocx(options);
      notify("File Downloaded", "success");
      setIsDownloading(false);
    } catch (error) {
      notify("Failed to download DOCX", "error");
      setIsDownloading(false);
    }
  };
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitSC && (
              <StyledButton variant="contained" onClick={toggleDrawer}>
                Add New Product
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitSC}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>NO data</>
                )
              }
              renderRowActions={({ row }) => (
                <ActionsMenu row={row} onEdit={onEdit} onDelete={onDelete} />
              )}
            />
          </Box>
          {SC_ID && (
            <ViewerModalPopup
              open={previewOpen}
              onClose={togglepreviewDrawer}
              title="Preview"
              onDownload={() => {
                if (SC_ID) {
                  downloadPDF(
                    API_ROUTES.SC_PREVIEW,
                    { scId: SC_ID },
                    scDetails?.scNo ? `${scDetails.scNo}.pdf` : `draft_sc_${SC_ID}.pdf`
                  );
                }
              }}
            >
              <div style={{ width: "100%", height: "100vh" }}>
                <PdfViewer
                  apiUrl={API_ROUTES.SC_PREVIEW}
                  params={{ scId: SC_ID }}
                  fileName={scDetails?.scNo || (SC_ID ? `draft_sc_${SC_ID}` : "scope_certificate")}
                />
              </div>
              {/* Embed the reusable PDF Viewer inside the modal */}
            </ViewerModalPopup>
          )}
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Add Product"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {((tableData.length > 0 && !drawerOpen) || apiData.length > 0) && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              {/* <FloatingButtonContainer isVisible={(tableData.length > 0 && !drawerOpen) || apiData.length > 0}> */}
              {/* <InnerButton
            onClick={handleSave}
            disabled={!hasChanges || isSaved}
          >
            Save
          </InnerButton> */}
              <NavLink to="/sc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>

              {completionMap["facility-product-details"] && (
                <>
                  <InnerButton onClick={handleSCSave}>Save</InnerButton>
                  <InnerButton onClick={handleSCSubmit}>Submit</InnerButton>
                </>
              )}
              <Tooltip title={"Click to Preview"}>
                <span>
                  <InnerButton onClick={togglepreviewDrawer}>
                    Preview
                  </InnerButton>
                </span>
              </Tooltip>
              <Tooltip title={"Click to Download"}>
                <span>
                  <InnerButton
                    onClick={handleDownload}
                    disabled={isDownloading}
                    sx={{
                      position: "relative",
                      "& .loading-indicator": {
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                      },
                    }}
                  >
                    {isDownloading ? (
                      <Box
                        className="loading-indicator"
                        display="flex"
                        alignItems="center"
                      >
                        <CircularProgress size={20} color="inherit" />
                      </Box>
                    ) : (
                      "Download Word"
                    )}
                  </InnerButton>
                </span>
              </Tooltip>
              {/* </FloatingButtonContainer> */}
            </Box>
          )}
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="No"
          />
        </>
      )}
    </>
  );
};

export default ProductManagementComponent;
